export enum OverlayContainerBlock {
  Root = 'OverlayContainer',
}

export enum OverlayContainerElement {
  Overlay = 'overlay',
  Content = 'content',
}
